import React from 'react';
import { Tooltip, Button, CircularProgress } from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

const { OutlinedCalendarIcon } = OutlinedIcons;

type RescheduleButtonProps = {
  isOverdue: boolean;
  isRescheduling: boolean;
  formattedDueDate: string;
  onReschedule: () => void;
};

const RescheduleButton = ({
  isOverdue,
  isRescheduling,
  formattedDueDate,
  onReschedule,
}: RescheduleButtonProps) => (
  <Tooltip title="Reschedule">

    <Button
      disabled={isRescheduling}
      variant="outlined"
      size="small"
      startIcon={
          isRescheduling ? (
            <CircularProgress size={18} />
          ) : (
            <OutlinedCalendarIcon sx={{ width: 18, height: 18 }} />
          )
        }
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onReschedule();
      }}
      sx={{
        backgroundColor: isOverdue ? 'warning.light' : 'white',
        borderColor: 'divider',
        color: 'text.primary',
        fontWeight: 700,
        fontSize: 13,
        px: 1.5,
        py: 1,
      }}
    >
      {formattedDueDate}
    </Button>

  </Tooltip>
);

export default RescheduleButton;
